import { render, staticRenderFns } from "./citizenship-dialog.vue?vue&type=template&id=7616b92c&"
import script from "./citizenship-dialog.vue?vue&type=script&lang=js&"
export * from "./citizenship-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports